export const ATS_STALE_IDLE_MS = 8000;
export const ATS_MAX_RUN_MS = 15 * 60 * 1000;

/**
 * Decide whether a tracked client ATS run should stop polling.
 * Idle with no activity log (including missing runId) times out so the
 * processing bar cannot spin forever after a failed activity insert.
 */
export function isTrackedRunSettled(run, row, now = Date.now()) {
  const status = row?.status;
  if (status === 'completed') return { settled: true, failed: false };
  if (status === 'failed') return { settled: true, failed: true };
  const age = run?.startedAt ? now - run.startedAt : 0;
  if (status === 'idle' && age > ATS_STALE_IDLE_MS) {
    return { settled: true, failed: true };
  }
  if (age > ATS_MAX_RUN_MS) {
    return { settled: true, failed: true };
  }
  return { settled: false, failed: false };
}
